import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBox, FDStack } from '@facet-wealth/design';


const BillingDetailsMobileRowLineItemLayout = () => {
  return (
    <FDBox>
      <MetaField attr="description" />
      <FDStack justifyContent={'space-between'} alignItems="flex-start">
        <FDStack direction={'row'} flexGrow={1} spacing={1} alignItems="flex-start" justifyContent="space-between">
          <MetaField attr="paymentMethod" />
          <MetaField attr="subTotal" />
        </FDStack>
      </FDStack>
    </FDBox>
  );
};

export default BillingDetailsMobileRowLineItemLayout;
